import { getSectionId } from './index'
import { StyledArticleContentWrapper } from './index.styled'

export type Props = {
  articleFontSize?: string | null
  articleId: string
  title: string
}
export const ArticleContentTitle = ({
  articleId,
  title,
  articleFontSize,
}: Props) => {
  return (
    <StyledArticleContentWrapper
      className="article-content-wrapper"
      data-size={articleFontSize || 'small'}
      style={{
        padding: 0,
        marginBottom: '-1em',
      }}
    >
      <h2
        id={getSectionId(articleId, title)}
        style={{
          scrollMarginTop: 105,
        }}
      >
        {title}
      </h2>
    </StyledArticleContentWrapper>
  )
}
